import React from 'react'

import CreateAccountCard from '@/housefolios-components/CreateAccount/CreateAccountCard'
import { AuthPageShell } from '@/housefolios-components/SignIn/authChrome'

export default function CreateAccountPage(props) {
  return (
    <AuthPageShell>
      <CreateAccountCard {...props} />
    </AuthPageShell>
  );
}
